<template>
    <r-e-dialog title="预览" show-footer :visible.sync="dialogVisible" width="600px" :footerBtnName="['取消', '打印']"
                @click-submit="clickSubmit" @click-cancel="clickCancel" @close="clickCancel">
        <div class="flex justify-center">
            <el-image :src="url" style="border: 1px solid #EEEEEE">
                <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                </div>
            </el-image>
            <!-- <div style="">
                <div style="display:flex;margin-bottom:25px">
                    <div>资产名称：</div>
                    <div style="border-bottom:1px solid #000;width:300px;text-align:center">{{info.asstesName}}</div>
                </div>
                <div style="display:flex;margin-bottom:25px">
                    <div>资产位置：</div>
                    <div style="border-bottom:1px solid #000;width:300px;text-align:center">{{info.name}}</div>
                </div>
                <div style="display:flex;margin-bottom:25px">
                    <div>规格型号：</div>
                    <div style="border-bottom:1px solid #000;width:300px;text-align:center">{{info.model}}</div>
                </div>
                <div>
                    <div style="display:flex;margin-bottom:25px">
                        <div>所属部门：</div>
                        <div style="border-bottom:1px solid #000;width:170px;text-align:center">{{info.company}}</div>
                    </div>
                    <div style="display:flex;margin-bottom:50px">
                        <div>资产编号：</div>
                        <div style="border-bottom:1px solid #000;width:170px;text-align:center">{{info.asstesSn}}</div>
                    </div>

                </div>
                    <div style="position:absolute;bottom:120px;right:120px">
                        <el-image :src="url" style="width:100px;height:100px">
                            <div slot="placeholder" class="image-slot">
                                加载中<span class="dot">...</span>
                            </div>
                        </el-image>
                    </div>



            </div> -->
        </div>
    </r-e-dialog>
</template>

<script>
import jcPrinterSdk from '@/assets/js/jcPrinterSdk_api_third';
import {combinationPrintData} from '../js/label-template';

export default {
    name: "layer-label-preview",
    data() {
        return {
            dialogVisible: false,
            loading: null,
            loadingOptions: {
                lock: true,
                text: "Loading...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            },
            url: null,
            combinationPrint: {}
        }
    },
    components: {},
    methods: {
        async openDialog(data) {
            // console.log(JSON.stringify(data));
            const {uuid, assetType, name, asstesName,asstesSn,model,company,assetsClassCodeName} = data;
            console.log('data',data);
            this.info = data;
            const {InitDrawingBoardParam, elements} = JSON.parse(JSON.stringify(combinationPrintData));
            console.log('elements',elements);
            console.log('InitDrawingBoardParam',InitDrawingBoardParam);
            elements[0].json.value = '资产位置:'+ name;
            elements[1].json.value = '资产编号:'+ asstesSn;
            elements[2].json.value = '规则型号:'+ model;
            elements[3].json.value = '资产名称:'+ asstesName;
            elements[4].json.value = '所属部门:'+ "昇达公司";
            elements[5].json.value = '资产大类:'+ assetsClassCodeName;
            elements[6].json.value = `https://rental.neoyon.com/h5/assets/index.html?uuid=${uuid}_;`;
            console.log('elements',elements);
            this.combinationPrint = {InitDrawingBoardParam, elements}
            console.log(this.combinationPrint);
            this.startPrintJobTest(true);
            this.dialogVisible = true;
        },
        clickSubmit() {
            const that = this;
            const loadingOptions = that.loadingOptions;
            that.loading = that.$loading({...loadingOptions});
            this.startPrintJobTest(false);
        },

        clickCancel() {
            this.dialogVisible = false;
            this.url = null;
        },

        startPrintJobTest(isPreview) {
            let contentArr = [];
            const that = this;
            const {combinationPrint} = this;
            contentArr.push(combinationPrint);
            jcPrinterSdk.batchPrintJob(that, contentArr, isPreview);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>
